/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2021-12-08 11:26:46
 * @LastEditors: quwandong
 * @LastEditTime: 2023-01-05 17:28:53
 */
const getters = {
  getCategorys(state) {
    return state.categorys;
  },
};
export default getters;
